import { Category, Item, Item_Exception, Order_Item, Price } from "../../models/RestModels";
import { OrderItemInfo } from "../../models/models";
import { getEmptyOrderItem } from './OrderItem';

export function getOrderItemInfo(item:Item,category:Category | null = null,price:Price | null = null, exceptions:Item_Exception[] = [],prices:Price[] = [])
{
		//let order_item:Order_Item = {
		//	discount_percent: 0,
		//	exceptions: '',
		//	item_id: item.id,
		//	qty: 1,
		//	tax: 0,
		//	item_group: Date.now(),
		//	tax_included: 'YES',
		//	unitary_price_meta: 0,
		//	original_unitary_price: price?.price ||0,
		//	stock_status: 'IN_STOCK',
		//	unitary_price: price?.price || 0,
		//	type:'NORMAL',
		//	total: price?.price || 0,
		//	is_free_of_charge: 'NO',
		//	note: ''
		//};

		let order_item = getEmptyOrderItem(item);
		order_item.unitary_price = price?.price || 0;
		order_item.total= price?.price || 0;

		let order_item_info:OrderItemInfo =
		{
			order_item,
			item: item,
			category: category,
			exceptions: exceptions,
			records: [],
			prices: prices,
			batches:[],
			options: [],
			order_item_exceptions: [],
			created: new Date(),
			serials:[],
			serials_string:'',
			commanda_type_id: 0
		}
		return order_item_info;
}
